import { render, staticRenderFns } from "./OrderExtend.vue?vue&type=template&id=1aa6de05&scoped=true&"
import script from "./OrderExtend.vue?vue&type=script&lang=js&"
export * from "./OrderExtend.vue?vue&type=script&lang=js&"
import style0 from "./OrderExtend.vue?vue&type=style&index=0&id=1aa6de05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa6de05",
  null
  
)

export default component.exports